export const DEFAULT_ROUTE = "/" || "/registration";

export const CONFIRMATION_ROUTE = "/confirmation";

export const REGISTRATION_SUCCESS_ROUTE = "/registration-success";